export default "__VITE_ASSET__d574dc6e__"